<!--
  ~ Copyright (C) 2017 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<div class="button" (click)="onDownloadCsvClick()">
  <span class="button__label">Export to CSV</span>
  <og-icon class="button__icon" name="file-spreadsheet" [size]="IconSize.Large"></og-icon>
</div>
